import { createContext } from 'react';

// Shares the multi-selection (an array of element indices) with ElementFrame
// so every element can render its group-selection highlight and participate in
// group drag-move without threading new props through all 12 element files.
const SelectionContext = createContext({
    multiSel: [],
    setMultiSel: () => { }
});

export default SelectionContext;
